import React, { useEffect, useRef, useState } from 'react';
import DeleteDialogueBox from '../Common/deleteDialogue';
import WizardServices from './WizardServices';

export function ContractWizardReserves(MainWizard: any) {

    console.log(MainWizard)
    let [searchFor, setsearchFor] = useState("");
    let [saveAlert, setSaveAlert] = useState(false);
    let [editRate, seteditRate] = useState<any>([]);
    let [deleteJob, setdeleteJob] = useState<any>([]);
    const formValidation = useRef<HTMLDivElement>(null);
    let [deleteAlert, setDeleteAlert] = useState(false);
    let [systemFormats, setsystemFormats] = useState<any>([]);
    let [systemRegions, setsystemRegions] = useState<any>([]);
    let [contractReserveListing, setcontractReserveListing] = useState<any>([]);
    let [contractReserveListingTemp, setcontractReserveListingTemp] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {


            WizardServices.contractssystemFormats({ publisherContract: "" }).then((value: any) => {
                setsystemFormats(value)
            })

            WizardServices.contractssystemsystemRegions(MainWizard.data.code.contractRefNum).then((value: any) => {
                setsystemRegions(value)
            })

            reserveListing();
        }
    }, []);

    useEffect(() => {
        seteditRate(editRate)
    }, [editRate]);

    const reserveListing = () => {

        WizardServices.contractReserveListing(MainWizard.data.code.contractRefNum).then((value: any) => {
            setcontractReserveListing(value)
            setcontractReserveListingTemp(value)
        })
    };

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...editRate };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        editRate = updatedObject;
        seteditRate(editRate);


    };

    const handleSpecificField = (fieldName: any, value: any, object: any) => {
        console.log(fieldName)
        console.log(object)
        console.log(value)

        let updatedObject = { ...editRate }
        if (fieldName === 'groupDesc,territoryCode') {
            var found = object.filter((event: any) => (event.groupDesc === (value)));
            updatedObject.groupDesc = found[0].groupDesc
            updatedObject.territoryCode = found[0].groupingId
        }

        if (fieldName === 'UsePriceDesc,usePrice') {
            var found = object.filter((event: any) => (event.value === (value)));
            updatedObject.UsePriceDesc = found[0] && found[0].value ? found[0].value : ''
            updatedObject.usePrice = found[0] && found[0].key ? found[0].key : ''
        }


        if (fieldName === 'formatDesc,format') {
            var found = object.filter((event: any) => (event.formatDesc === (value)));
            updatedObject.formatDesc = found[0].formatDesc
            updatedObject.format = found[0].codingStr
        }

        editRate = updatedObject;
        seteditRate(editRate);
    };

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })
        return valid;
    }

    const contractReserveSearch = (e: any) => {

        console.log(e)
        if (e.length > 0) {
            var listSearch = contractReserveListingTemp.filter((value: any) =>
                value.releaseType.toLowerCase().includes(e.toLowerCase()) ||
                value.groupDesc.toLowerCase().includes(e.toLowerCase())
            );
            setcontractReserveListing(listSearch)
        } else {
            setcontractReserveListing(contractReserveListingTemp)
        }

    };

    const onReserveDelete = (e: any) => {
        setdeleteJob(e)
        console.log(e)
    };

    const clearSForm = () => {

        editRate = {}
        seteditRate({ ...editRate })
        const inputs: any = formValidation.current?.querySelectorAll('input');
        if (inputs) {
            Object.values(inputs).map((values: any) => {
                var fieldName: any = document.getElementById(values.id);
                if (fieldName) {
                    fieldName.style.border = "1px solid #47529d";
                }


            })
        }

    };

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            WizardServices.contractReserveDelete(MainWizard.data.code.contractRefNum, deleteJob.reserveId).then(() => {
                setDeleteAlert(true);
            })
            setTimeout(function () {
                setDeleteAlert(false);
            }, 3000);
        }

        setdeleteJob({});
    };

    const onReserveSave = () => {
        console.log(editRate)

        var valid = handleFieldRequired(editRate)

        editRate.contractRefNum = MainWizard.data.code.contractRefNum;

        if (valid) {
            WizardServices.contractReserveSave(MainWizard.data.code.contractRefNum, editRate).then(() => {
                setSaveAlert(true);
                reserveListing();
            })

            setTimeout(function () {
                setSaveAlert(false);
            }, 3000);

        }
    }

    return (
        <div className="ws-12">

            <div className='ws-12 ps'>
                <div className='box'>

                    <div className="box-header well"> <h2>Contract Reserves</h2> </div>

                    <div className='box-content'>

                        <div className="ws-12" ref={formValidation}>
                            <div className="ws-6 pm">
                                <label className='ws-12 text-bold'>Region*</label>
                                <div className="label-entries">
                                    <select className='ws-11 full-height' value={editRate.groupDesc ?? ""} required
                                        onChange={(e) => { handleSpecificField("groupDesc,territoryCode", e.target.value, systemRegions) }}>
                                        <option value="">Choose region</option>

                                        {systemRegions?.map((values: any, index: any) => {
                                            return (
                                                <option value={values.groupDesc} label={values.groupDesc} >{values.groupDesc}</option>
                                            )
                                        })}

                                    </select>
                                </div>
                            </div>

                            <div className="ws-6 pm">
                                <label className='ws-12 text-bold'>Format/Source Codes*</label>
                                <div className="label-entries">
                                    <select className='full-height' value={editRate.formatDesc ?? ""} required
                                        onChange={(e) => { seteditRate({ ...editRate, releaseType: e.target.value }) }}>
                                        <option value="">Choose Format/Source Codes</option>
                                        {
                                            systemFormats?.map((values: any, index: any) => {
                                                return (
                                                    <option value={values.formatDesc} label={values.formatDesc} >{values.formatDesc}</option>
                                                )
                                            })}

                                    </select>
                                </div>

                            </div>

                            <div className="ws-6 pm">
                                <label className='ws-12 text-bold'>Periods*</label>
                                <input className="label-entries ws-11" type="number" name="noOfPeriods" onChange={(e) => handleFieldChange(e)} value={editRate.noOfPeriods ?? ""} required />
                            </div>

                            <div className="ws-6 pm">
                                <label className='ws-12 text-bold'>Percentage*</label>
                                <input className="label-entries ws-12" type="number" name="percentage" onChange={(e) => handleFieldChange(e)} value={editRate.percentage ?? ""} required />
                            </div>

                        </div>

                    </div>

                    <div className=' box-footer pull-right'>
                        <button className='icon-btn edit' onClick={() => onReserveSave()}>Save</button>
                        <button className='btn-pink' onClick={() => { clearSForm() }}>Reset</button>

                    </div>
                </div>
            </div>

            <div className='ws-12 ps'>
                <div className='box'>
                    <div className="box-header">
                        <h2>{contractReserveListing.length} <span>record(s) found</span> </h2>
                    </div>

                    <div className="box-content">
                        {saveAlert && <div className="alert alert-info"> Rates/Basis has been saved successfully</div>}
                        {deleteAlert && <div className="alert alert-info">Rates/Basis has been deleted successfully</div>}

                        <div className="form-horizontal row-fluid" >
                            <div className="form-format ws-8 pbl">
                                <label className="pts mts pr ws-12 text-bold" >Filter</label>

                                <div className="ws-9">
                                    <input type="text" className="form-control ws-12" value={searchFor} placeholder="Search" id="rate"
                                        onChange={(e) => { setsearchFor(e.target.value); contractReserveSearch(e.target.value) }} />
                                </div>
                            </div>
                        </div>
                        {(contractReserveListing.length === 0) && <div className="alert alert-info" >No records to display</div>}

                        {(contractReserveListing.length > 0) && <div className="ws-12 allowVscroll" style={{ height: "200px" }}>
                            <table className="newTable" >
                                <thead>
                                    <tr>
                                        <th className='text-bold'>Region</th>
                                        <th className='text-bold'>Format/Source Codes</th>
                                        <th className='text-bold'>Periods</th>
                                        <th className='text-bold'>Percentage</th>
                                        <th className='text-bold'>Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contractReserveListing?.map((values: any) => {
                                        return (
                                            <tr>
                                                <td> {values.groupDesc} ({values.territoryCode})</td>
                                                <td> {values.formatDesc}</td>
                                                <td className="text-right ">{values.noOfPeriods}</td>
                                                <td className="text-right ">{values.percentage}</td>
                                                <td >
                                                    <a className="btn-sm icon-btn edit" onClick={() => seteditRate(values)}><i className="icon-edit1"></i></a>
                                                    <a className="btn-sm icon-btn delete" onClick={() => onReserveDelete(values)}><i className="icon-trashcan"></i></a>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>}
                    </div>
                </div>
            </div>


            {
                (() => {

                    if (deleteJob && deleteJob.reserveId) {
                        return <DeleteDialogueBox param={true} message={"delete region " + deleteJob.groupDesc + "(" + deleteJob.territoryCode + ")"} onChange={Confirmation} />
                    }
                })()
            }
        </div>

    );
}
